var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHistoric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9965 5.46442C15.8249 5.46442 16.4965 6.13599 16.4965 6.96442V14.3725L19.2783 17.1544C19.8641 17.7402 19.8641 18.6899 19.2783 19.2757C18.6926 19.8615 17.7428 19.8615 17.157 19.2757L13.9358 16.0545C13.6545 15.7732 13.4965 15.3917 13.4965 14.9938V6.96442C13.4965 6.13599 14.168 5.46442 14.9965 5.46442Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26465 15C3.26465 8.51878 8.51872 3.26471 14.9999 3.26471C21.4812 3.26471 26.7352 8.51878 26.7352 15C26.7352 21.4812 21.4812 26.7353 14.9999 26.7353C11.8166 26.7353 8.92931 25.4689 6.81382 23.4087L8.26584 23.4106C9.09426 23.4116 9.76668 22.7409 9.76771 21.9124C9.76875 21.084 9.09802 20.4116 8.26959 20.4106L3.27825 20.4043C2.8801 20.4038 2.49809 20.5616 2.21638 20.843C1.93467 21.1244 1.77637 21.5062 1.77637 21.9043L1.77637 26.9019C1.77637 27.7303 2.44795 28.4019 3.27637 28.4019C4.1048 28.4019 4.77637 27.7303 4.77637 26.9019V25.6116C7.42482 28.1635 11.029 29.7353 14.9999 29.7353C23.138 29.7353 29.7352 23.1381 29.7352 15C29.7352 6.86193 23.138 0.264709 14.9999 0.264709C6.86186 0.264709 0.264648 6.86193 0.264648 15C0.264648 15.8284 0.936221 16.5 1.76465 16.5C2.59308 16.5 3.26465 15.8284 3.26465 15Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistoric);
export default __webpack_public_path__ + "static/media/ic_historic.52b26db35353e4d22e90a2201cd6c92c.svg";
export { ForwardRef as ReactComponent };